<!-- <mat-card fxLayoutGap class="dialog-box">

    <p mat-dialog-title>{{data.title}}</p>

    <p class="text">{{data.message}}</p>

	<p class="question">Voulez-vous continuer?</p>


    <div mat-dialog-actions>
		<span [ngClass]="{'action-button': true, 'secondary-button': true}" (click)="onDismiss()">Non</span>
		<span [ngClass]="{'action-button': true, 'primary-button': true}" (click)="onConfirm()">Oui</span>
    </div>
</mat-card> -->

<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ data.title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <p class="text">{{ data.message }}</p>
            <p class="text">Voulez-vous continuer?</p>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [mat-dialog-close]="false">Non</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="true">Oui</button>
    </mat-card-actions>
</mat-card>
